// extracted by mini-css-extract-plugin
export var quantityInput = "_oy-0";